// @flow
import type { Location } from 'react-router';

export const getQueryParams = (location: Location) => {
  const queryParams = new URLSearchParams(location.search);
  const orgId = queryParams.get('orgId');
  const orchestrationId = queryParams.get('orchId');
  const versionId = queryParams.get('versionId');
  return { orgId, orchestrationId, versionId };
};

export const ALL_PATH = '/all';



// WEBPACK FOOTER //
// ./src/util/RouterUtils.js